<template lang="pug">
    div
        div.text-h6  {{ marker.Name }}
        p Charging your <em><strong>{{ car.Name }}</strong></em> here from 10% to 80% would take about {{ chargeTime }} and cost about {{ chargeCost }}
        p(v-if="marker.EnergyPercent") Driving here will use about <strong>{{ energyPercent }}%</strong> of your battery
        v-btn.primary(v-if="canCenter",@click="centerRadar") Drive from here

</template>

<script>
export default {
    props:["car","marker","settings", "canCenter"],
    computed: {
        chargeTime: function() {
            return this.calculateChargeTime(this.car, this.marker.Charger);
        },
        chargeCost: function() {
           return "$" + this.formatPrice(this.calculateChargeCost(this.car, this.marker.Charger, this.settings));
        },
        energyPercent: function() {
            return this.marker.EnergyPercent.toFixed(0);
        }

    },
    methods: {
        centerRadar() {
            this.$emit("centerRadar",this.marker);
        }
    }
}
</script>